const dictionary = {
  about: "About",
  accountancy: "Accountancy",
  achievements: "Achievements",
  anaf: "ANAF (National Agency for Fiscal Administration)",
  antiDrugAgency: "National Anti-drug Agency",
  aprSolutions: "Apr Solutions SRL",
  athens: "Athens",
  awards: "Awards",
  bacau: "Bacau",
  birthday: "Birthday",
  bucharest: "Bucharest",
  bucharestRomania: "Bucharest, Romania",
  brand: "iliedorobat.ro",
  cikmConference: "International Conference on Information and Knowledge Management (CIKM)",
  clujNapoca: "Cluj-Napoca",
  computerScience: "Computer Science",
  contExpert: "Cont Expert SA",
  cyprus: "Cyprus",
  degree: "Degree",
  designMobila: "Design Mobila SRL",
  drivingLicense: "Driving License",
  dubai: "Dubai",
  education: "Education",
  email: "E-mail",
  europeana: "Europeana",
  experience: "Experience",
  expertIt: "Expert IT",
  fieldOfStudy: "Field of study",
  freelancer: "Freelancer",
  github: "Github",
  greece: "Greece",
  home: "Home",
  icdsConference: "International Conference on Digital Society (ICDS)",
  italy: "Italy",
  languageSkills: "Language Skills",
  lecturer: "Lecturer",
  location: "Location",
  luxoft: "Luxoft SRL",
  luxoftJobTitle: "Senior Software Developer @ Luxoft",
  margineni: "Margineni",
  ministryOfFinance: "Ministry of Finance",
  networksAndMemberships: "Networks & Memberships",
  norway: "Norway",
  organisationalSkills: "Organisational Skills",
  oslo: "Oslo",
  owner: "Owner",
  papers: "Papers",
  phd: "PhD",
  pitesti: "Pitesti",
  principalTechStack: "Principal Tech Stack",
  professionalPath: "Professional Path",
  projects: "Projects",
  researchProject: "Research Project",
  resume: "Resume",
  romania: "Romania",
  seniorSoftwareDeveloper: "Senior Software Developer",
  socialActivities: "Social Activities",
  softwareDeveloper: "Software Developer",
  techStack: "Tech Stack",
  turin: "Turin",
  unitedArabEmirates: "United Arab Emirates",
  ub: "\"Vasile Alecsandri\" University of Bacău",
  upb: "University Politehnica of Bucharest",
  upbNew: "National University of Science and Technology Politehnica Bucharest",
  upbJobTitle: "Lecturer @ UPB",
  volunteer: "Volunteer",
  webdata: "WebData",
  website: "Website",
};

export { dictionary as LABELS };
